import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ParameterService } from '../../../services/parameter.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PaymentService } from '../../../services/payment.service';
import { Payment } from '../../../models/payment';
import { TranslateService } from '@ngx-translate/core';

declare var StripeCheckout: any;

@Component({
  selector: 'app-stripe-checkout',
  templateUrl: './stripe-checkout.component.html',
  styleUrls: ['./stripe-checkout.component.css']
})
export class StripeCheckoutComponent implements OnInit, OnDestroy {
  @Input() chamberId: string;
  @Input() paymentToken: string;
  @Input() source: string;
  @Input() userId: string;

  @Output() paymentSucces: EventEmitter<any> = new EventEmitter();
  @Output() paymentError: EventEmitter<any> = new EventEmitter();

  loading: boolean;

  //stripeCheckoutInfo: SCheckout;

  private apiURL = environment.apiURL;

  private headers = new HttpHeaders({'Content-Type': 'application/json'});

  stripeWindow: any;

  constructor(private http: HttpClient, private parameterService: ParameterService, private domSanitizer: DomSanitizer,
              private paymentService: PaymentService, private translateService: TranslateService) { }

  ngOnInit() {
    this.loading = false;
  }

  ngOnDestroy() {
    if (this.stripeWindow) {
      this.stripeWindow.close();
    }
  }

  onClickPay() {
    this.loading = true;
    this.paymentService.getPayment(this.paymentToken, this.chamberId)
    .then((payment: Payment) => {
      this.loading = false;
      this.stripeWindow = StripeCheckout.configure({
        key: payment.StripeCheckout.PublishableKey,
        image: this.parameterService.getSmallBrandLogo(),
        locale: payment.StripeCheckout.Locale,
        token: this.launchPayment(this.chamberId, this.paymentToken)
      });
      this.stripeWindow.open({
        name: this.parameterService.getParameter().ShortName,
        currency: payment.StripeCheckout.Currency,
        amount: payment.StripeCheckout.Amount,
        panelLabel: this.translateService.currentLang == 'fr' ? 'Payer' : 'Pay',
        zipCode: true,
        allowRememberMe: false,
        email: payment.StripeCheckout.Email
      });
    })
    .catch((error) => {
      this.loading = false;
      this.paymentError.emit(error);
    });
  }

  private launchPayment(chamberId: string, paymentToken: string): any {
    return (cardToken) => {
      this.loading = true;
      this.PostStripePayment(cardToken.id, chamberId, paymentToken)
      .then(() => {
        this.loading = false;
        this.paymentSucces.emit(null);
      })
      .catch((error) => {
        this.loading = false;
        this.paymentError.emit(error);
      });
    };
  }

  public PostStripePayment(cardToken: string, chamberId: string, paymentToken: string): Promise<any> {
    let callbackUrl = this.apiURL + 'payment/' + cardToken + '/stripe?chamberid=' + chamberId + '&paymenttoken=' + paymentToken;
    if (this.source && this.source.trim() !== '') {
      callbackUrl += '&paymentsource=' + this.source;
    }
    if (this.userId && this.userId.trim() !== '') {
      callbackUrl += '&userid=' + this.userId;
    }

    const callHeaders: HttpHeaders = this.headers;
    return this.http.post<any>(callbackUrl, null, {headers: callHeaders})
    .toPromise()
    .then(response => response)
    .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.error || error.message || error);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/stripe-checkout/stripe-checkout.component.ts